export enum LoginStatuses {
    UnknownError = 0,
    Success = 1,
    InvalidUsernamePassword = 2,
    LockedOut = 3,
    RequiresTwoFactor = 4,
    InvalidToken = 5,
    ExpiredPassword = 6,
    Deactivated = 7
}